import i18n from 'i18n/config';

export default (platform: 'ios' | 'android' = 'ios') => {
  const language = i18n.language.toLowerCase();

  switch (platform) {
    case 'android':
      return 'https://play.google.com/store/apps/details?id=com.unmind.mobile';

    default:
      switch (language) {
        case 'pt-br':
          return 'https://apps.apple.com/br/app/unmind/id1327302257';

        default:
          return 'https://apps.apple.com/app/unmind-nurture-your-mind/id1327302257';
      }
  }
};
